export * from './CallTrackingApi';
import { CallTrackingApi } from './CallTrackingApi';
export * from './OnlineBookingApi';
import { OnlineBookingApi } from './OnlineBookingApi';
export * from './SearchApi';
import { SearchApi } from './SearchApi';
export const APIS = [CallTrackingApi, OnlineBookingApi, SearchApi];
